// extracted by mini-css-extract-plugin
module.exports = {"title":"rich-title_title__sIefB"};